import React, { useEffect, useState } from 'react';
import './PWAPrompt.css';

const PWAPrompt = () => {
    const [show, setShow] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

    useEffect(() => {
        // تحقق من حالة التخزين في sessionStorage بدلاً من localStorage
        const isDismissed = sessionStorage.getItem('pwaPromptDismissed');
    
        if (isDismissed === 'true') return;
    
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || (navigator as any).standalone
            || document.referrer.includes('android-app://');
    
        if (isStandalone) return;
    
        const handleBeforeInstallPrompt = (e: Event) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShow(true);
        };
    
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);
    

    const handleInstall = async () => {
        if (deferredPrompt) {
            try {
                await deferredPrompt.prompt();
                const choiceResult = await deferredPrompt.userChoice;

                if (choiceResult.outcome === 'accepted') {
                    //console.log('تم تثبيت التطبيق');
                }

                setDeferredPrompt(null);
                setShow(false);
            } catch (error) {
                console.error('خطأ في تثبيت التطبيق:', error);
            }
        }
    };

    const handleDismiss = () => {
        // استخدام sessionStorage بدلاً من localStorage
        sessionStorage.setItem('pwaPromptDismissed', 'true');
        setShow(false);
    };
    

    if (!show) return null;

    return (
        <div className="pwa-prompt">
            <div className="pwa-content">
                <div className="pwa-icon">
                    <svg viewBox="0 0 24 24" className="arrow-icon">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="white" />
                    </svg>
                </div>
                <div className="pwa-text">
                    <h3>تثبيت التطبيق</h3>
                    <p>احصل على تجربة أفضل مع تطبيقنا</p>
                </div>
            </div>
            <div className="pwa-buttons">
                <button onClick={handleInstall} className="install-button">
                    <span>تثبيت</span>
                    <svg viewBox="0 0 24 24" className="arrow-icon">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="white" />
                    </svg>
                </button>
                <button onClick={handleDismiss} className="cancel-button">
                    لاحقاً
                </button>
            </div>
        </div>
    );
};

export default PWAPrompt; 